import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import FileInput from "./FileInput";
import { CameraIcon, CheckCircleIcon } from "../../assets/icons";
import { BsCloudUpload } from "react-icons/bs";
import toast from "react-hot-toast";
import axios from "axios";
import i18n from "../../i18n/i18n";

export default function MediaSelect({
  index,
  documentType,
  documentCode,
  sessionId,
  funcUploadStatus,
  defaultPreview,
  defaultState
}) {
  const canvasRef = useRef();
  const videoRef = useRef(null);
  // const [file, setFile] = useState(null);
  const [mode, setMode] = useState(0);
  const [preview, setPreview] = useState(defaultPreview);
  const [state, setState] = useState(defaultState);
  const { t } = useTranslation();

  const [stream, setStream] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // const [photo, setPhoto] = useState(null);
  // const [facingMode, setFacingMode] = useState("environment"); 

  const apiUrl = import.meta.env.VITE_API_URL;

  // const launchCam = () => {
  //   navigator.mediaDevices
  //     .getUserMedia({ video: true })
  //     .then((stream) => {
  //       setMode(1);
  //       videoRef.current.srcObject = stream;
  //     })
  //     .catch((err) => console.error("Camera error:", err));

  //   return () => {
  //     setMode(0);
  //     stopVideoStream();
  //   };
  // };

  const detectCameras = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(d => d.kind === "videoinput");
    setCameras(videoDevices);
    return videoDevices;
  };

  const launchCam = async (ndx = 0) => {
    try {
      const videoDevices = cameras.length ? cameras : await detectCameras();

      if (!videoDevices.length) {
        alert("No camera found");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: { exact: videoDevices[ndx].deviceId }
        }
      });

      videoRef.current.srcObject = stream;
      setStream(stream);
      setCurrentIndex(ndx);

      setMode(1);
    } catch (err) {
      console.error("Camera error:", err);
    }
  }

  const switchCamera = async () => {
    if (cameras.length <= 1) return;

    const next = (currentIndex + 1) % cameras.length;

    stopVideoStream();

    launchCam(next)
  };

  const stopVideoStream = () => {
    // videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }

    setMode(0);
  };

  const capturePhoto = () => {
    const width = videoRef.current.videoWidth;
    const height = videoRef.current.videoHeight;

    const canvas = canvasRef.current;
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(videoRef.current, 0, 0, width, height);

    const dataUrl = canvas.toDataURL("image/jpeg");
    setPreview(dataUrl);

    stopVideoStream()

    canvas.toBlob(async (blob) => {
        const file = new File([blob], randFilename(), {
          type: "image/jpeg"
        });

        // setFile(file);

        uploadDocument(file);
    })

    // const blob = await (await fetch(dataUrl)).blob();
    // const file = new File([blob], randFilename(), { type: "image/jpeg" });

    // setFile(file);
  };

  const randFilename = () => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < 10; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result + ".jpg";
  };

  const handleChoseFile = (file) => {
    // setFile(file);

    setPreview(URL.createObjectURL(file));

    uploadDocument(file)
  };

  const uploadDocument = async (imageFile = null) => {
    setState("U");
    try {
      const formData = new FormData();

      if (imageFile == null) {
        toast.error(
          t(
            "pages.registration.verification_documents.messages.select_an_image",
            { type: t(`verification_documents.types.${documentType}`) }
          )
        );
        setState("P");
      } else {
        // const imageFile = (file == null) ? capturedImg : file

        formData.append("file", imageFile);

        const response = await axios.post(
          apiUrl + "/api/v1/registration/uploads/kycdocs",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Accept-Language": i18n.language || "en",
            },
          }
        );

        axios.post(
          apiUrl + "/api/v1/registration/kyc-document",
          {
            sessionId: sessionId,
            documentType: documentCode,
            reference: response.data.reference,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": i18n.language || "en",
            },
          }
        );

        setState("C");
        funcUploadStatus(index, true);
      }
    } catch (err) {
      setState("P");
      console.log(err);
    }
  };

  return (
    <>
      <canvas ref={canvasRef} className="hidden" />
      <div className="hover:border-brand-500! dark:hover:border-brand-500! rounded-xl border border-dashed! border-gray-300! bg-gray-50 p-2 lg:p-3 dark:border-gray-700! dark:bg-gray-900 mt-2">
        <img
          src={preview}
          alt="preview"
          className={`h-full w-full object-cover ${mode == 0 ? "" : "hidden"}`}
        />

        <div
          className={`w-full relative h-[300px] ${mode == 1 ? "" : "hidden"}`}
        >
          <video ref={videoRef} autoPlay playsInline />
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2">
            <button 
              type="button" 
              onClick={switchCamera} 
              className="mr-4 bg-black text-white dark:bg-white dark:text-gray-400 px-2 py-1"
              >Switch Camera</button>
            <button
              type="button"
              onClick={capturePhoto}
              className="mr-4 bg-black text-white dark:bg-white dark:text-gray-400 px-2 py-1"
            >
              {t("buttons.capture")}
            </button>
            <button
              type="button"
              onClick={stopVideoStream}
              className="bg-black px-2 py-1 text-white dark:bg-white dark:text-gray-400"
            >
              {t("buttons.close")}
            </button>
          </div>
        </div>
      </div>

      <div
        className={`space-y-1 border-t border-gray-100 p-2 sm:p-1 dark:border-gray-800 ${
          mode == 1 ? "hidden" : ""
        }`}
      >
        {state == "C" ? (
          <CheckCircleIcon className="text-green-600 text-2xl" />
        ) : (
          <div className="flex flex-row w-full">
            <div className="flex-1/2 flex flex-row">
                <FileInput callbackFunc={handleChoseFile} />
                <button type="button" className="ml-2" onClick={() => launchCam()}>
                  <CameraIcon />
                </button>
            </div>
            {/* <div className="flex-1/2 text-right">
              <button
                type="button"
                disabled={state == "U"}
                onClick={uploadDocument}
                className="text-center text-blue-500 flex flex-row p-2"
                title="Upload"
              >
                <BsCloudUpload className="pr-1 text-2xl" />
                <span>
                  {state == "U" ? t("buttons.uploading") : t("buttons.upload")}
                </span>
              </button>
            </div> */}
          </div>
        )}
      </div>
    </>
  );
}
